import React from 'react';
import cn from 'classnames';
import Form from '../../../../form/Form';
import InputField from '../../../../form/InputField';
import SelectField from '../../../../form/SelectField';
import FormError from '../../../../form/FormError';
import Button from '../../../../common/ui/Button';
import { MOUSEFLOW_MASKED } from '../../../../../constants/mouseflowClasses';
import { US_STATES } from '../../../../../constants';
import { getStateCode } from '../../../../../utils/helpers';
import styles from './styles.module.scss';

const AddressForm = ({ formik, address }) => {
  const showSave =
    formik.values.address1 !== address?.address1 ||
    formik.values.address2 !== address?.address2 ||
    formik.values.city !== address?.city ||
    formik.values.province !== getStateCode(address?.province) ||
    formik.values.zip !== address?.zip ||
    formik.values.first_name !== address?.first_name ||
    formik.values.last_name !== address?.last_name ||
    formik.values.phone !== (address?.phone || '');
  return (
    <Form className={styles.form} formik={formik}>
      <div className={styles.row}>
        <label>First Name</label>
        <InputField
          className={styles.inputWrapper}
          name="first_name"
          formik={formik}
          placeholder="First name"
        />
      </div>
      <div className={styles.row}>
        <label>Last Name</label>
        <InputField
          className={styles.inputWrapper}
          name="last_name"
          formik={formik}
          placeholder="Last name"
        />
      </div>{' '}
      <div className={styles.row}>
        <label>Address Line 1</label>
        <InputField
          className={styles.inputWrapper}
          name="address1"
          formik={formik}
          placeholder="Address Line 1"
        />
      </div>{' '}
      <div className={styles.row}>
        <label>Address Line 2 (optional)</label>
        <InputField
          className={styles.inputWrapper}
          name="address2"
          formik={formik}
          placeholder="Address Line 2 (optional)"
        />
      </div>
      <div className={styles.row}>
        <label>City</label>
        <InputField
          className={styles.inputWrapper}
          name="city"
          formik={formik}
          placeholder="City"
        />
      </div>
      <div className={styles.row}>
        <label>State</label>
        <SelectField
          className={styles.inputWrapper}
          name="province"
          formik={formik}
          options={US_STATES}
        />
      </div>
      <div className={styles.row}>
        <label>Zip</label>
        <InputField
          className={styles.inputWrapper}
          name="zip"
          formik={formik}
          placeholder="Zip"
        />
      </div>
      <div className={styles.row}>
        <label>Phone</label>
        <InputField
          className={cn(MOUSEFLOW_MASKED, styles.inputWrapper)}
          name="phone"
          formik={formik}
          placeholder="+19991234567"
        />
      </div>
      <FormError error={formik.status} />
      <div className={styles.buttons}>
        {showSave && (
          <Button type="submit" className={styles.save}>
            Confirm Address
          </Button>
        )}
      </div>
    </Form>
  );
};

export default AddressForm;
